import { render, staticRenderFns } from "./VgtHeaderRow.vue?vue&type=template&id=ee4e5ec6"
import script from "./VgtHeaderRow.vue?vue&type=script&lang=js"
export * from "./VgtHeaderRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports